import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../../../api/api";
import "../../../../components/table.css";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Pagination from "../../../../components/Pagination";
import BackButton from "../../../../components/BackButton";
import usePagination from "../../../../utils/usePagination";
import Table from "../../../../components/table";

const ListofBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(bookings, 5);

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const response = await api.get("/booking/booking-list");
        // console.log("response", response);

        setBookings(response.data.enquiries);
      } catch (error) {
        console.error("Failed to fetch bookings:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBookings();
  }, []);

  const columns = [
    { label: "Booking No.", accessor: "booking_id" },
    { label: "POL", accessor: "pol" },
    { label: "POD", accessor: "pod" },
    { label: "Status", accessor: "Status_client" },
    {
      label: "Action",
      render: (row) => (
        <>
          <div className="d-flex gap-2 justify-content-center ">
            {row.Status_client === 'Quotation Accepted' && (
              <>
                <Link to={`/my-bookings/view-bookings/${row.enq_id}`} title="View">
                  <VisibilityIcon style={{ fontSize: 20 }} />
                </Link>
                <Link
                  to={`/my-bookings/create-shipping-instructions/${row.enq_id}`}
                  title="create"
                >
                  <EditIcon style={{ fontSize: 20 }} />
                </Link>
              </>
            )}
            {row.Status_client === 'Shipping Instruction Created' && (
              <Link to={`/view-si/admin/${row.enq_id}`} title="View SI">
                <VisibilityIcon style={{ fontSize: 20 }} />
              </Link>
            )}
            {row.booking_doc_status !== "Submitted" && (
              <Link
                to={`/upload-documents/${row.enq_id}`}
                title="Upload Document"
              >
                <UploadFileIcon style={{ fontSize: 20 }} />
              </Link>
            )}
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <BackButton />
      <Table
        columns={columns}
        data={currentItems}
        loading={loading}
        emptyMessage="No exchange rates found."
        itemsPerPage={itemsPerPage}
        pagination={
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
            totalItems={totalItems}
          />
        }
      />
    </>
  );
};
export default ListofBookings;
